/*
 * These are in this file because they are in the middleware.js file which runs
 * on Vercel with edge config and we cannot import decrypt or other things into
 * that
 */
export const HOME_URL = '/';
export const MAINTENANCE_URL = '/maintenance';
